// Saves one review PNG to the reviewer's device. The image sits behind the
// session cookie on the API's origin, where `<a download>` is ignored, so it
// is fetched with credentials and saved from a blob URL instead. That also
// lets the page show a refusal (a 404 JSON body) instead of navigating to it.
export async function saveDownload(url, filename) {
    let response
    let blob
    try {
        response = await fetch(url, { credentials: 'include', mode: 'cors' })
        if (!response.ok) {
            const body = await response.json().catch(() => ({}))
            // An expired session: the caller hands it to the app's logout.
            if (body.result === 'UNAUTHORIZED') return { ok: false, unauthorized: true }
            return { ok: false, error: body.error || null }
        }
        // Inside the try: the body can still break mid-stream (the server
        // destroys the response on an S3 error; a phone drops off).
        blob = await response.blob()
    } catch {
        return { ok: false, error: null }
    }
    const href = URL.createObjectURL(blob)
    const anchor = document.createElement('a')
    anchor.href = href
    anchor.download = filename
    anchor.rel = 'noopener'
    document.body.appendChild(anchor)
    anchor.click()
    anchor.remove()
    // Later, not now: some browsers (iOS Safari) read the URL after click returns.
    setTimeout(() => URL.revokeObjectURL(href), 60000)
    return { ok: true }
}
